// @flow
import React from 'react';

import NotificationSettingsAllRow from './NotificationSettingsAllRow';
import NotificationSettingsHeader from './NotificationSettingsHeader';
import NotificationSettingsRow from './NotificationSettingsRow';

import type { NotificationSetting } from '../constants';

type Props = {
    settingsList: Array<any>,
    token: string
};

const NotificationSettingsList = ({ settingsList, token }: Props) => {
    let includeEmail = true;
    let includePush = true;
    const settings = settingsList.map((setting: NotificationSetting) => {
        includeEmail = includeEmail && setting.email;
        includePush = includePush && setting.push;
        return (
            <NotificationSettingsRow
                key={setting.title}
                title={setting.title}
                pushKey={setting.push && setting.push.key}
                emailKey={setting.email && setting.email.key}
                token={token}
            />
        );
    });

    return (
        <div className="settings-container">
            <div className="settings-header-container">
                <NotificationSettingsHeader
                    includeEmail={includeEmail}
                    includePush={includePush}
                />
                <NotificationSettingsAllRow
                    includeEmail={includeEmail}
                    includePush={includePush}
                    token={token}
                />
            </div>
            <ul className="settings-list">{settings}</ul>
        </div>
    );
};

export default NotificationSettingsList;



// WEBPACK FOOTER //
// ./src/v5/notificationSettings/components/NotificationSettingsList.jsx